import axios from 'axios';
import { saveAs } from 'file-saver';

export const checkRequest = async (id) => {
  return await axios({
    url: `/admin/check-request/${id}`
  }).then((res) => res.data);
};

export const resolveRequest = async ({ id, body }) => {
  return await axios({
    url: `/admin/resolve-request/${id}`,
    method: 'PUT',
    data: body
  }).then((res) => res.data);
};

export const approveAndExportRequests = async ({ params }) => {
  const response = await axios.get(`/finance/resolve-requests?${params.toString()}`, {
    headers: { 'Content-Type': 'text/csv; charset=UTF-8' }
  });
  const blob = new Blob([response.data], { type: 'text/csv' });
  if (params.get('exportByDate') === 'true') {
    saveAs(blob, params.get('from') + ' to ' + params.get('to') + ' Requests Summary.csv');
  } else {
    saveAs(blob, 'Unexported Requests Summary.csv');
  }
  return response;
};

export const exportRequests = async ({ params }) => {
  const response = await axios.get(`/admin/export-requests?${params.toString()}`, {
    headers: { 'Content-Type': 'text/csv; charset=UTF-8' }
  });
  const blob = new Blob([response.data], { type: 'text/csv' });
  if (params.get('exportByDate') === 'true') {
    saveAs(blob, params.get('from') + ' to ' + params.get('to') + ' Requests Summary.csv');
  } else {
    saveAs(blob, 'Unexported Requests Summary.csv');
  }
  return response;
};
